const hiringAuthorities = [
    {
      value: 'vra',
      displayValue: 'Veterans Recruitment Appointment (VRA)',
      tooltip: 'For veterans with service-connected disabilities or those who served in specific campaigns or expeditions.'
    },
    {
      value: '30_percent_veteran',
      displayValue: '30% or More Disabled Veteran',
      tooltip: 'For veterans with a 30% or more service-connected disability. Non-competitive appointment.'
    },
    {
      value: 'veoa',
      displayValue: 'Veterans Employment Opportunities Act (VEOA)',
      tooltip: 'Allows preference-eligible veterans to apply for certain federal jobs without competition.'
    },
    {
      value: 'military_spouse',
      displayValue: 'Military Spouse Non-Competitive Appointment',
      tooltip: 'For spouses of active duty members of the armed forces, disabled veterans, or service members killed while on duty.'
    },
    {
      value: 'schedule_a',
      displayValue: 'Schedule A Hiring Authority for Individuals with Disabilities',
      tooltip: 'For individuals with severe physical, intellectual, or psychiatric disabilities.'
    },
    {
      value: 'dha_students_recent_grads',
      displayValue: 'Direct Hire Authority (Students and Recent Graduates)',
      tooltip: 'Allows federal agencies to hire students and recent graduates directly for hard-to-fill positions.'
    },
    {
      value: 'pathways',
      displayValue: 'Pathways Programs',
      tooltip: 'Federal internship and career development programs for students, recent graduates, and Presidential Management Fellows.'
    },
    {
      value: 'peace_corps',
      displayValue: 'Returned Peace Corps Volunteer (RPCV)',
      tooltip: 'Non-competitive eligibility for individuals who completed Peace Corps service.'
    },
    {
      value: 'americorps',
      displayValue: 'AmeriCorps VISTA',
      tooltip: 'Non-competitive eligibility for individuals who completed AmeriCorps VISTA service.'
    },
    {
      value: 'ctap',
      displayValue: 'Career Transition Assistance Plan (CTAP)',
      tooltip: 'Priority hiring for federal employees displaced by downsizing or restructuring.'
    },
    {
      value: 'ictap',
      displayValue: 'Interagency Career Transition Assistance Plan (ICTAP)',
      tooltip: 'Priority hiring for displaced federal employees from other agencies.'
    },
    {
      value: 'lmwfa',
      displayValue: 'Land Management Workforce Flexibility Act (LMWFA)',
      tooltip: 'Allows temporary seasonal employees in land management agencies to compete for permanent positions.'
    },
    {
      value: 'post_secondary_dha',
      displayValue: 'Post-Secondary Students and Recent Graduates Direct Hire Authority',
      tooltip: 'Allows agencies to directly hire post-secondary students and recent graduates for specific positions.'
    },
    {
    "value": "veterans_preference",
    "displayValue": "Veterans' Preference",
    "tooltip": "Provides priority in federal hiring for qualified veterans.",
    }
  ];
  
  export default hiringAuthorities;
  